export enum StickyPopupOpenModes {
  mouseLeave = 'onMouseLeave',
  onInit = 'onInit',
}

export enum StickyPopupTemplates {
  banner = 'banner',
  modal = 'modal',
  footer = 'footer',
}
